import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function NetProfitReturnOnSales() {
    const [netProfit, setNetProfit] = useState(0);
    const [sales, setSales] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {
        setTotal((parseInt(netProfit) / parseInt(sales)) *100);
    }, [netProfit, sales])

    function clickResult() {
        history.push(
            {
                pathname: `/netprofitreturnonsalesresult?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        netProfit: numberValidation,
        sales: numberValidation
    });

    const def = <span>Total Dealership Net Profit ÷ Total Dealership Sales</span>;

    return (
        <Formik
            initialValues={{ netProfit: "", sales: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Net Profit Return On Sales</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="netProfit">
                                            <Form.Label>Total Dealership Net Profit</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="netProfit" isInvalid={!!errors.netProfit}
                                                value={values.netProfit} onChange={e => { handleChange(e); setNetProfit(e.target.value) }}
                                            />
                                                <Form.Control.Feedback type="invalid">{errors.netProfit}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="sales">
                                            <Form.Label>Total Dealership Sales</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="sales" isInvalid={!!errors.sales}
                                                value={values.sales} onChange={e => { handleChange(e); setSales(e.target.value) }}
                                            />
                                                <Form.Control.Feedback type="invalid">{errors.sales}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function NetProfitReturnOnSalesResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Net Profit Return On Sales";
    const total = urlParams.get('total') + "%";
    const ratio = "4.0%";
    const cond = parseFloat(total) >= 4;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}


export {
    NetProfitReturnOnSales,
    NetProfitReturnOnSalesResult
}